import { title } from 'process';
import { createContext, useEffect, useReducer, useState } from 'react';
import { useForm } from 'react-hook-form';
import { getProjectsList } from '../apis/bounties/bountyDraft';
import { useParams, useSearchParams } from 'react-router-dom';
import { getBounty } from '../apis/bounties/bounties';
import { useLoadingState } from '../hooks/useLoader';
import Loader from '../ui/Loader';
import { getOrganization } from '../apis/oragnisations/organisation';

const initialState = {
    title: '',
    description: '',
    organisationId: '',
    projectId: '',
    cores: [],
    type: '',
    mode: 'digital',
    city: '',
    location: { coordinates: [] },
    bountyRadius: 50,
    maxAcceptancesPerUser: '',
    criteria: [''],
    microtasks: [],
    totalRewardAmount: 0,
    noOfWinners: 1,
    passThreshold: '',
    expirationTime: null,
    estimatedCompletionTime: '',
    validationTillDate: null,
    day: '',
    hours: '',
    minutes: '',
    distributionMode: 'Distribute evenly between all winners',
    rank1: 0,
    rank2: 0,
    rank3: 0,
    core: '',
    SDGs: [],
    backer: {
        name: '',
        message: '',
    },
    doughnutMetrics: [],
    // rewardPerUser
};
export const BountiesContext = createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case 'setTitle':
            return { ...state, title: action.payload };

        default:
            return state;
    }
};

export const BountiesProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [org, setOrg] = useState({});
    const [projects, setProjects] = useState([]);
    const [active, setActive] = useState(1);
    const { id } = useParams();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const {
        loading: gettingInitialDetails,
        startLoading: startGettingInitialDetails,
        stopLoading: stopGettingInitialDetails,
    } = useLoadingState();
    const [bounty, setBounty] = useState({});
    const [searchParams] = useSearchParams();
    const bountyId = searchParams.get('bountyId');

    const {
        handleSubmit,
        control,
        getValues,
        register,
        trigger,
        formState: { errors },
    } = useForm({
        mode: 'onChange',
        defaultValues: initialState,
    });

    const handleStepChange = async (nextStep) => {
        // if (nextStep === 2) {
        //     handleManualValueSetting(nextStep, 'superPowers', selectedPowers);
        //     return;
        // }
        // if (nextStep < step) {
        //     setStep(nextStep);
        //     return;
        // }

        const isValid = await trigger(); // Manually trigger validation for all fields
        if (isValid) {
            setActive(nextStep);
        } else {
            console.log('Validation failed');
        }
    };

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startGettingInitialDetails();
                    const [data, data2] = await Promise.all([getProjectsList(id), getOrganization(id)]);
                    console.log(data2, 'this is org details');
                    setOrg(data2);
                    setProjects(data);
                } catch (error) {
                    console.log(error);
                } finally {
                    stopGettingInitialDetails();
                }
            };
            fetchData();
        },
        [id]
    );
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startLoading();
                    const data = await getBounty(bountyId);

                    setBounty(data);
                } catch (error) {
                    console.log(error);
                } finally {
                    stopLoading();
                }
            };
            if (bountyId) fetchData();
        },
        [bountyId]
    );

    if ((Object.keys(bounty)?.length === 0 && bountyId) || loading)
        return (
            <div className="flex items-center justify-center h-[30vh] w-full col-span-3  ">
                <Loader />
            </div>
        );
    if (Object.keys(org)?.length === 0 || gettingInitialDetails)
        return (
            <div className="flex items-center justify-center h-[30vh] w-full col-span-3  ">
                <Loader />
            </div>
        );
    return (
        <BountiesContext.Provider
            value={{
                state,
                handleSubmit,
                projects,
                control,
                errors,
                dispatch,
                register,
                active,
                setActive,
                handleStepChange,
                isEdit: Boolean(bountyId),
                loadingEditDetails: loading,
                bountyEditDetails: bounty,
                organisation: org,
            }}
        >
            {children}
        </BountiesContext.Provider>
    );
};

// {

//    "backer": {
//              "name": "Backer",
//              "message": "message here"
//          },
//          "rewardToken": {
//              "tokenAddress": "sfdsfsfsf",
//              "totalRewardAmount": 500,
//              "distribution": [200,100,100,50,50]
//          },
//   "hasImpactCertificate": false,
//          // impactBrief is optional and must be specified ony if
//   "impactBrief": "Helped in testing the application 'Impact Miner'",
//   "cores": ["Earth"],
//   "SDGs":["Climate action", "Partnerships for the goals"],
//   "doughnutMetrics": ["income & work"],
//   "maxAcceptancesPerUser": 1
// }
